import React from 'react';
import SmartCardTemplate from '../components/smartcard/Templates/SmartCardPersonal';

export default function SmartCardPersonalPreview() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-10">
      <SmartCardTemplate
        name="Senthil Kumar"
        role1="Investor"
        role2="Author"
        cardNumber="4389 0012 1234 4567"
        tier="Royal"
        mode="Personal"
        isVerified={true}
        isTrusted={false}
        reviewCount={0}
        qrCodeUrl="https://million2trillion.com/r/123456"
        photoUrl="/user-photos/john-doe.jpg"
        joinedOn="2025-03-14"
        cardValidity="2026-03-14"
        businessCode="M2T-JD123"
        showLogo={true} // ✅ only set to true for previews
      />
    </div>
  );
}
